/* global JitsiMeetJS */

import React, { useState } from "react";
import QuickMessages from "./QuickMessages";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from "react-toastify";
import { API_BASE_URL } from "../helpers/constant";
import { interpreterUpdateService } from "../Services/interceptorServices";
import { useSelector } from 'react-redux';

export default function InterpreterListing({ eventDetail, participantData, oParticipantData, refresh }) {
    const { joinedUsers, remoteTracksArray } = useSelector((state) => state.connection);
    const [pFormValues, setPFormValues] = useState({
        participant_id: "",
        name: "",
        is_connected: "",
        booth_language_id: ""
    });
    const [name, setName] = useState("");


    const getBooths = () => {
        if (eventDetail && eventDetail.languages) {

            let sortedLanguages = Object.values(eventDetail.languages).map(value => value).sort();

            return sortedLanguages.map((booth, index) => {
                let id = Object.keys(eventDetail.languages).find((key) => {
                    return eventDetail.languages[key] === booth;
                });

                return <option key={index} value={id}  >{booth}</option>
            });
        }
        return <></>

    }

    const updateParticipant = () => {
        let payload = {}
        if (name && name !== pFormValues.name) {
            payload.name = pFormValues.name
        }
        interpreterUpdateService({
            participant_id: pFormValues.participant_id,
            booth_language_id: pFormValues.booth_language_id,
            is_connected: pFormValues.is_connected,
            ...payload
        }).then(resp => {
            console.log("***changeParticipantName***", resp.data);
            if (resp && resp.data && resp.data.code === 200) {
                document.getElementById("closeModal").click();
                refresh();
                toast.success("Participant updated successfully!");
            } else if (resp && resp.data && resp && resp.data.errors.length) {
                toast.error(resp.data.errors[0]);
            }
        }).catch((err) => {
            toast.error("Something went wrong!");
            console.log("***err***", err);
        });

    }

    const getStreamData = (pId) => {
        let jitsiPid = "";
        Object.keys(joinedUsers).map((id, mainIndex) => {
            if (joinedUsers[id] && joinedUsers[id]._properties && joinedUsers[id]._properties.participant_type &&
                joinedUsers[id]._properties.participant_type === "interpreter" &&
                joinedUsers[id]._properties.participantId === pId) {
                jitsiPid = id;
            }
        });
        if (jitsiPid) {
            let existingTrack = remoteTracksArray.find(item => item.id === jitsiPid);
            if (existingTrack && existingTrack.tracks.length > 0) {
                return existingTrack.tracks.map(track => {
                    if (track.getType() === "audio") {
                        return <audio autoPlay='1' ref={(refData) => { refData && track && track.attach(refData) }} id={`${jitsiPid}-audio-${pId}`} />
                    }
                    return <> </>

                });
            }
        }
    }

    const getMuteStatus = (pId) => {
        let jitsiPid = "";
        Object.keys(joinedUsers).map((id, mainIndex) => {
            if (joinedUsers[id] && joinedUsers[id]._properties && joinedUsers[id]._properties.participant_type &&
                joinedUsers[id]._properties.participant_type === "interpreter" &&
                joinedUsers[id]._properties.participantId === pId) {
                jitsiPid = id;
            }
        });
        let isMuted = true;
        if (jitsiPid) {
            let existingTrack = remoteTracksArray.find(item => item.id === jitsiPid);
            if (existingTrack && existingTrack.tracks.length > 0) {
                existingTrack.tracks.map(track => {
                    if (track.getType() === "audio" && !track.isMuted()) {
                        isMuted = false;
                    }

                });
            }
        }
        return isMuted;
    }

    const getAudioStatus = (pId) => {
        let audioStatus = false;
        Object.keys(joinedUsers).map((id, mainIndex) => {
            if (joinedUsers[id] && joinedUsers[id]._properties && joinedUsers[id]._properties.participant_type &&
                joinedUsers[id]._properties.participant_type === "interpreter" &&
                joinedUsers[id]._properties.participantId === pId) {
                audioStatus = joinedUsers[id]._properties.boothmatesMute;
            }
        });
        return <i className={`fas ${audioStatus ? "fa-volume-mute" : "fa-volume-up"} `}></i>;

    }

    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <div className="clearfix mb-3">
                        <div className="float-left">
                            <h5>{eventDetail && eventDetail.name}</h5>
                        </div>
                        <div className="float-right">
                            <div className="hint" id="moderator-listening-channel-hint">Select a channel through which to listen.</div>
                            <div className="form-inline">
                                <i className="fa-regular fa-ear fa-lg mr-2" data-toggle="tooltip" title="Listening To"></i>
                                <select name="language_id" className="custom-select bg-light border border-dark" onchange="xajax_Moderator_icp_console.update_language(this.value); $('.tooltip').remove()">
                                    <option value="0">No interpretation</option>
                                    {getBooths()}
                                </select>

                                <span className="link-separator mx-2">|</span>
                                <button className="btn btn-light btn-sm border-secondary" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="fa-regular fa-ticket" data-toggle="tooltip" title="Invite People"></i>
                                </button>
                                <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-scrollable modal-sm">
                                        <div className="modal-content" >
                                            <div className="modal-header" style={{ position: 'relative', display: 'flex' }}>
                                                <h4 className="modal-title" id="exampleModalLabel"><i className="fa-regular fa-ticket fa-sm mr-2"></i>Invite</h4>
                                                <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                            </div>

                                            <div className="modal-body">
                                                <div className="modal-body" id="modal-body">
                                                    <div className="card border pb-3">
                                                        <div className="card-body">
                                                            <div className="form-group">
                                                                <label className="control-label">Interpreter code</label>
                                                                <div className="col-sm-12">
                                                                    <div className="input-group input-group-sm">
                                                                        <input type="text" name="interpreter_code" id="interpreter-code" value={eventDetail && eventDetail.interpreter_code} readOnly="readonly" className="form-control form-control-sm text-center bg-light border border-dark" />
                                                                        <div className="input-group-append">
                                                                            {eventDetail &&
                                                                                <CopyToClipboard text={window.location.origin + "/join/" + eventDetail.interpreter_code}
                                                                                    onCopy={() => toast.success("Code Copied Successfully!")}>
                                                                                    <button data-toggle="tooltip" title="" className="btn btn-sm btn-info" data-original-title="Copy to clipboard">
                                                                                        <i className="fa-solid fa-link"></i>
                                                                                    </button>
                                                                                </CopyToClipboard>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label className="control-label">Client code</label>
                                                                <div className="col-sm-12">
                                                                    <div className="input-group input-group-sm">
                                                                        <input type="text" name="client_code" value={eventDetail && eventDetail.client_code} id="client-code" readOnly="readonly" className="form-control form-control-sm text-center bg-light border border-dark" />
                                                                        <div className="input-group-append">
                                                                            {eventDetail &&
                                                                                <CopyToClipboard text={window.location.origin + "/join/" + eventDetail.client_code}
                                                                                    onCopy={() => toast.success("Code Copied Successfully!")}>
                                                                                    <button data-toggle="tooltip" title="Copy to clipboard" className="btn btn-sm btn-info" >
                                                                                        <i className="fa-solid fa-link"></i>
                                                                                    </button>
                                                                                </CopyToClipboard>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label className="control-label">Technician code</label>
                                                                <div className="col-sm-12">
                                                                    <div className="input-group input-group-sm">
                                                                        <input type="text" name="moderator_code" value={eventDetail && eventDetail.moderator_code} id="moderator-code" readOnly="readonly" className="form-control form-control-sm text-center bg-light border border-dark" />
                                                                        <div className="input-group-append">
                                                                            {eventDetail &&
                                                                                <CopyToClipboard text={window.location.origin + "/join/" + eventDetail.moderator_code}
                                                                                    onCopy={() => toast.success("Code Copied Successfully!")}>
                                                                                    <button data-toggle="tooltip" title="Copy to clipboard" className="btn btn-sm btn-info" >
                                                                                        <i className="fa-solid fa-link"></i>
                                                                                    </button>
                                                                                </CopyToClipboard>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="text-center" style={{ position: 'relative', top: '-30px' }}>
                                                        {eventDetail &&
                                                            <CopyToClipboard text={`Interpreter Code - ${window.location.origin}/join/${eventDetail.interpreter_code} Technician Code - ${window.location.origin}/join/${eventDetail.moderator_code} Client Code - ${window.location.origin}/join/${eventDetail.client_code}`}
                                                                onCopy={() => toast.success("Code Copied Successfully!")}>
                                                                <button className="btn btn-light btn-sm border border-secondary" >
                                                                    Copy All<i className="fa-solid fa-link ml-2"></i>
                                                                </button>
                                                            </CopyToClipboard>
                                                        }

                                                        <div className="mt-4">
                                                            <a href={`${API_BASE_URL}/invite/index/5`} target="_blank" >More invitation options...</a>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-2 text-right">
                        <QuickMessages />
                    </div>
                    <div id="interpreters-pane" className="table-responsive">
                        <div className="table-responsive">
                            <div id="interpreter_bloc_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <table className="table table-hover table-striped table-bordered table-sm w-100 dataTable no-footer text-center" id="interpreter_bloc" style={{ width: '100%' }} role="grid">
                                    <thead>
                                        <tr className="bg-table-header" role="row">
                                            <th className="dt-head-center dt-body-center sorting" tabIndex="0" aria-controls="interpreter_bloc" rowspan="1" colSpan="1" aria-label="Interpreter Name: activate to sort column ascending" style={{ width: '418.2px' }} data-bs-toggle="modal" data-bs-target="#exampleModal1"> <a> Interpreter Name </a> </th>
                                            <th className="dt-head-center dt-body-center sorting_desc" tabIndex="0" aria-controls="interpreter_bloc" rowspan="1" colSpan="1" aria-label="Booth: activate to sort column ascending" aria-sort="descending" style={{ width: '187.2px' }}>Booth</th>
                                            <th className="dt-head-center dt-body-center sorting" tabIndex="0" aria-controls="interpreter_bloc" rowspan="1" colSpan="1" aria-label=": activate to sort column ascending" style={{ width: '101.2px' }}><i className="fa-solid fa-message-lines fa-message" data-toggle="tooltip" title="Actively Interpreting" data-original-title="Actively Interpreting"></i></th>
                                            <th className="dt-head-center dt-body-center sorting" tabIndex="0" aria-controls="interpreter_bloc" rowspan="1" colSpan="1" aria-label=": activate to sort column ascending" style={{ width: '93.2px' }}><i className="fa-solid fa-microphone" style={{ font_size: '1rem' }} dataToggle="tooltip" title="Mic Status" dataOriginalTitle="Mic Status"></i></th>
                                            <th className="dt-head-center dt-body-center sorting" tabIndex="0" aria-controls="interpreter_bloc" rowspan="1" colSpan="1" aria-label=": activate to sort column ascending" style={{ width: '91.2px' }}><i className="fa-solid fa-ear" style={{ font_size: '1rem' }} data-toggle="tooltip" title="Audio Status"></i></th></tr>
                                    </thead>
                                    <tbody>
                                        {participantData.length > 0 && participantData.map(p => {
                                            return (
                                                <tr className="odd">
                                                    <td className=" dt-head-center dt-body-center ">
                                                        <a data-bs-toggle="modal" data-bs-target="#participnatModal"
                                                            onClick={() => {
                                                                setPFormValues({
                                                                    participant_id: p.participant_id,
                                                                    name: p.name,
                                                                    is_connected: p.is_connected,
                                                                    booth_language_id: p.booth_language_id
                                                                });
                                                                setName(p.name);
                                                            }}
                                                        >{p.name}</a>
                                                        {getStreamData(p.participant_id)}

                                                    </td>
                                                    <td className="dt-head-center dt-body-center sorting_1">
                                                        <a >{p.booth_language_name}</a>
                                                    </td>
                                                    <td className=" dt-head-center dt-body-center "></td>
                                                    <td className=" dt-head-center dt-body-center ">{getMuteStatus(p.participant_id) ? <i className="fa-solid fa-microphone-slash" style={{ font_size: '1rem' }} dataToggle="tooltip" title="Mic Status" dataOriginalTitle="Mic Status"></i> : <i className="fa-solid fa-microphone" style={{ font_size: '1rem' }} dataToggle="tooltip" title="Mic Status" dataOriginalTitle="Mic Status"></i>}</td>
                                                    <td className=" dt-head-center dt-body-center ">{getAudioStatus(p.participant_id)}</td>
                                                </tr>
                                            )
                                        })}
                                        {oParticipantData.length > 0 && oParticipantData.map(p => {
                                            return (
                                                <tr className="odd">
                                                    <td className=" dt-head-center dt-body-center ">
                                                        <a data-bs-toggle="modal" data-bs-target="#participnatModal"
                                                            onClick={() => {
                                                                setPFormValues({
                                                                    participant_id: p.participant_id,
                                                                    name: p.name,
                                                                    is_connected: p.is_connected,
                                                                    booth_language_id: p.booth_language_id
                                                                });
                                                                setName(p.name);
                                                            }}
                                                        >{p.name}</a>
                                                        {getStreamData(p.participant_id)}
                                                    </td>
                                                    <td className="dt-head-center dt-body-center sorting_1">
                                                        <a >{p.booth_language_name}</a>
                                                    </td>
                                                    <td className=" dt-head-center dt-body-center "></td>
                                                    <td className=" dt-head-center dt-body-center ">{getMuteStatus(p.participant_id) ? <i className="fa-solid fa-microphone-slash" style={{ font_size: '1rem' }} dataToggle="tooltip" title="Mic Status" dataOriginalTitle="Mic Status"></i> : <i className="fa-solid fa-microphone" style={{ font_size: '1rem' }} dataToggle="tooltip" title="Mic Status" dataOriginalTitle="Mic Status"></i>}</td>
                                                    <td className=" dt-head-center dt-body-center ">{getAudioStatus(p.participant_id)}</td>
                                                </tr>
                                            )
                                        })}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
            <div className="modal fade" id="participnatModal" tabIndex="-1" aria-labelledby="participnatModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-sm">
                    <div className="modal-content" >
                        <div className="modal-header" style={{ position: 'relative', display: 'flex' }}>
                            <h4 className="modal-title" >Interpreter</h4>
                            <button type="button" id={"closeModal"} className="close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div id="participant-form">
                                <div className="form-group">
                                    <label>Name</label>
                                    <input name="name" type="text" className="form-control bg-light border border-dark"
                                        onChange={(e) => {
                                            setPFormValues({
                                                ...pFormValues,
                                                name: e.target.value
                                            });
                                        }}
                                        value={pFormValues.name} />
                                </div>
                                <div className="form-check form-check-inline ml-2">
                                    <input type="checkbox" name="is_connected" value={pFormValues.is_connected} checked={pFormValues.is_connected == "1" ? "checked" : ""} className="form-check-input"
                                        onChange={() => {
                                            setPFormValues({
                                                ...pFormValues,
                                                is_connected: pFormValues.is_connected == "1" ? "0" : "1"
                                            });
                                        }}
                                    />
                                    <div className="form-check-label">Connected</div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer" id="modal-footer" >
                            <div className="text-right">
                                <button type="button" className="btn btn-primary" onClick={() => updateParticipant()}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >

    );
}